import React, {Fragment} from 'react';
import Box from "../UI/Box";
import UserThematicList from "./UserThematicList";
import UserView from "./UserView";
import ChangePasswordView from "./ChangePasswordView";

const UserDetails = (props) => {
    return <Fragment>
        <Box>
            <UserView userId={props.userId}/>
        </Box>
        <Box>
            <ChangePasswordView userId={props.userId}/>
        </Box>
        <Box title="User thematics">
            <UserThematicList userId={props.userId}/>
        </Box>
    </Fragment>;
}

export default UserDetails;